import styled from 'styled-components';
import { selectThemeSemantics } from '../../../../styling';
import { Icon } from '../../../icon';
import { ToolbarCommand } from '../../../toolbar';

export const CommandButton = styled(ToolbarCommand) <{ $isActive?: boolean, $disabled?: boolean }>`
    background-color: ${({ $isActive, $disabled, theme: { semantics: { palette } } }) => ($disabled ? palette.neutralQuaternary : ($isActive ? palette.themeLighterAlt : palette.white))};
    padding: ${selectThemeSemantics(({ gap }) => `${gap.none} ${gap.l}`)};

    ${Icon} {
        fill: ${({ $isActive, $disabled, theme: { semantics: { palette } } }) => ($disabled ? palette.neutralPrimaryAlt : ($isActive ? palette.themePrimary : palette.neutralPrimary))};
    }
`;
